import * as SurveyCore from "survey-core";
import SetContactMaxLengthAndValue from "./common/SetContactMaxLengthAndValue";
import SetLeadMaxLengthAndValue from "./common/SetLeadMaxLengthAndValue";
import i18next from "../../common/localization/i18n";
import FormStateParams from "../interfaces/FormStateParams";
import { SupportedCRM } from "../../common/enums/SupportedCRM";
import Countries from "../../common/data/Countries";
import SetMapperAttributes from "../../common/helpers/SetMapperAttributes";
import { EntityType } from "../../common/enums/EntityType";

function CountryToolbox(formStateParams: FormStateParams) {
  if (!SurveyCore.Serializer.findClass("country_field")) {
    const elementName = i18next.t("NEW_FORM_EDITOR.QUESTION_TYPES.COUNTRY");

    SurveyCore.ComponentCollection.Instance.add({
      name: "country_field",
      title: "Country",
      iconName: "icon-country",
      elementsJSON: [
        {
          type: "dropdown",
          name: elementName,
          titleLocation: "hidden",
          allowClear: true,
        },
      ],
      onLoaded: (question) => {
        const innerDropdown = question.contentPanel.getQuestionByName(elementName);
        innerDropdown.choices = Countries.map((c) => ({
          text: c.name,
          value: c.code,
        }));
        innerDropdown.optionsCaption = question.placeholder;

        question.registerFunctionOnPropertyValueChanged("placeholder", () => {
          innerDropdown.optionsCaption = question.placeholder;
        });
      },
    });

    SurveyCore.Serializer.addProperty("country_field", {
      name: "crmMaxLength",
      type: "number",
      default: 1,
      isSerializable: true,
      visible: false,
    });
    SurveyCore.Serializer.addProperty("country_field", {
      name: "crmContactMaxLength",
      type: "number",
      default: 1,
      isSerializable: true,
      visible: false,
    });
    SurveyCore.Serializer.addProperty("country_field", {
      name: "crmLeadMaxLength",
      type: "number",
      default: 1,
      isSerializable: true,
      visible: false,
    });

    SurveyCore.Serializer.addProperty("country_field", {
      name: "contactMap",
      displayName: i18next.t("NEW_FORM_EDITOR.COMPONENT_COMMON.CONTACT_MAP"),
      isRequired: false,
      category: "toolboxMapperCategory",
      type: "dropdown",
      isSerializable: true,
      onPropertyEditorUpdate: (obj: any, editor: any) => {
        editor.allowClear = true;
      },
      onSetValue: (surveyElement: any, value: any) => {
        SetContactMaxLengthAndValue(surveyElement, value, "contact", "text");
      },
      choices: (obj: any, choicesCallback: any) => {
        if (!choicesCallback) return;
        obj.clearErrors();
        SetMapperAttributes("text", choicesCallback, formStateParams, EntityType.Contact, obj);
      },
      visibleIndex: 1,
      categoryIndex: 8,
    });

    if (formStateParams.supportedCRM === SupportedCRM.MSCRM) {
      SurveyCore.Serializer.addProperty("country_field", {
        name: "leadMap",
        displayName: i18next.t("NEW_FORM_EDITOR.COMPONENT_COMMON.LEAD_MAP"),
        isRequired: false,
        category: "toolboxMapperCategory",
        type: "dropdown",
        isSerializable: true,
        onPropertyEditorUpdate: (obj: any, editor: any) => {
          editor.allowClear = true;
        },
        onSetValue: (surveyElement: any, value: any) => {
          SetLeadMaxLengthAndValue(surveyElement, value, "lead", "text");
        },
        choices: (obj: any, choicesCallback: any) => {
          if (!choicesCallback) return;
          obj.clearErrors();
          SetMapperAttributes("text", choicesCallback, formStateParams, EntityType.Lead, obj);
        },
        visibleIndex: 1,
        categoryIndex: 8,
      });
    }

    SurveyCore.Serializer.addProperty("country_field", {
      name: "overrideInCrmMap",
      displayName: i18next.t("NEW_FORM_EDITOR.COMPONENT_COMMON.OVERRIDE_IN_CRM"),
      isRequired: false,
      category: "toolboxMapperCategory",
      type: "boolean",
      visibleIndex: 2,
      categoryIndex: 8,
    });

    SurveyCore.Serializer.addProperty("country_field", {
      name: "placeholder",
      category: "general",
      default: "Select...",
    });
  }
}

export default CountryToolbox;
